import { compose, hoistStatics, lifecycle, withHandlers, withState, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';

import KBPost from './KBPost';
import KbPostService from '../../../../services/kbPost.service';


let myScroll = null;

const goToPage = props => async (nextPage) => {
  const { setPostsCriteria,
    setPostsCount,
    postsCriteria,
    setHasMore,
    postsCount,
    setPosts,
    isLoad,
    posts } = props;
  if (!isLoad) {
    const page = nextPage > -1 ? nextPage : 0;
    if (postsCriteria.limit * (page + 1) >= postsCount) setHasMore(false);
    const { data, count } = await KbPostService.getData({ ...postsCriteria, page });
    setPosts([...posts, ...data]);
    setPostsCount(count);
    setPostsCriteria({ ...postsCriteria, page });
  }
};

const preLoad = async (props) => {
  const { setPosts, setPostsCount, postsCriteria, setIsLoad, setPageStart, setHasMore } = props;
  setIsLoad(true);
  setPageStart(0);
  const { data, count } = await KbPostService.getData(postsCriteria);
  setPosts(data);
  setPostsCount(count);
  setHasMore(postsCriteria.limit < count);
  myScroll.scrollTo({ x: 0, y: 100, animated: true });
  setIsLoad(false);
};
const enhance = compose(
  connect(null, null),
  translate('portal'),
  withState('hasMore', 'setHasMore', true),
  withState('isLoad', 'setIsLoad', true),
  withState('pageStart', 'setPageStart', 0),
  withPropsOnChange(['activeCategory'], async (props) => {
    if (props.activeCategory) await preLoad(props);
  }),
  withHandlers(() => ({
    onRef: () => ref => (myScroll = ref),
    goToPage,
  })),
);

export default withRouter(hoistStatics(enhance)(KBPost));



// WEBPACK FOOTER //
// ./src/views/modules/kb/kbPostList/index.js